import React from 'react'

export interface AppTableColumnProps {
	title?: string
	field?: string
	width?: number
	render?: (data: any, dataIndex: number) => JSX.Element | string
	sorter?: boolean
	sortField?: string
	align?: 'left' | 'right' | 'center'
	format?: string
	expand?: boolean
	dataType?:string
	className?:string
}


class AppTableColumnCheckbox extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		width: 60,
		title: '',
		field: '_table_check_box',
		align: 'center',
	}
}

class AppTableColumnIndex extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		width: 60,
		title: '序号',
		field: '_table_index',
		align: 'center',
	}
}

class AppTableColumnDate extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'center',
		format: 'YYYY-MM-DD',
		dataType:'date'
	}
}

class AppTableColumnDateTime extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'center',
		format: 'YYYY-MM-DD HH:mm:ss',
		dataType:'date'
	}
}
class AppTableColumnInt extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'right',
		format: '#,###',
		dataType:'number'
	}
}

class AppTableColumnMoney extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'right',
		format: '#,###.00',
		dataType:'number'
	}
}

class AppTableColumnAction extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'right',
		title: '操作',
	}
}

export class AppTableColumn extends React.Component<AppTableColumnProps> {
	static defaultProps: AppTableColumnProps = {
		align: 'left',
		format: '',
	}

	static Checkbox = AppTableColumnCheckbox;
	static Index = AppTableColumnIndex;
	static Date = AppTableColumnDate;
	static DateTime = AppTableColumnDateTime;
	static Int = AppTableColumnInt;
	static Money = AppTableColumnMoney;
	static Action = AppTableColumnAction;
}




// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableColumn.tsx